import { createSlice } from '@reduxjs/toolkit';
import { saveToLocalStorage, loadFromLocalStorage } from './helpers/localStorage.js';

const initialState = {
  selectedRestaurantId: loadFromLocalStorage('selectedRestaurantId') || null, // Load from localStorage
};

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setRestaurantId: (state, action) => {
      state.selectedRestaurantId = action.payload;
      saveToLocalStorage('selectedRestaurantId', action.payload); // Save to localStorage
    },
  },
});

export const { setRestaurantId } = restaurantSlice.actions;
export default restaurantSlice.reducer;
